module.exports = __webpack_public_path__ + "img/Note.43ca9f7b.png";